// Constants - Functions
import { protocols } from "../../../../config/constants";
import { importImages } from "../../../../config/functions";

export const GetProtocolData = (protocolId) => {
  const protocolImg = importImages(require.context("../../../../assets/images/protocols/prescriptions/icu", false, /\.(png|jpe?g|svg)$/));
  const protocolReportImg = importImages(require.context("../../../../assets/images/protocols/reports/icu", false, /\.(png|jpe?g|svg)$/));

  const protocolsData = {
    [protocols.icu.THE_GARDEN.id]: {
      img: protocolImg["./garden.png"],
      reportImg: protocolReportImg["./garden.png"],
      name: "garden",
      video: "gardenVideo",
      description: "gardenDescription",
    },
    [protocols.icu.THE_BEACH.id]: {
      img: protocolImg["./beach.png"],
      reportImg: protocolReportImg["./beach.png"],
      name: "beach",
      video: "beachVideo",
      description: "beachDescription",
    },
    [protocols.icu.THE_AQUARIUM.id]: {
      img: protocolImg["./aquarium.png"],
      reportImg: protocolReportImg["./aquarium.png"],
      name: "aquarium",
      video: "aquariumVideo",
      description: "aquariumDescription",
    },
    [protocols.icu.THE_UNIVERSE.id]: {
      img: protocolImg["./universe.png"],
      reportImg: protocolReportImg["./universe.png"],
      name: "universe",
      video: "universeVideo",
      description: "universeDescription",
    },
    [protocols.icu.THE_NUMBERS.id]: {
      img: protocolImg["./numbers.png"],
      reportImg: protocolReportImg["./numbers.png"],
      name: "numbers",
      video: "numbersVideo",
      description: "numbersDescription",
    },
    [protocols.icu.THE_RIVER.id]: {
      img: protocolImg["./river.png"],
      reportImg: protocolReportImg["./river.png"],
      name: "river",
      video: "riverVideo",
      description: "riverDescription",
    },
    [protocols.icu.THE_BUTTERFLIES.id]: {
      img: protocolImg["./butterflies.png"],
      reportImg: protocolReportImg["./butterflies.png"],
      name: "butterflies",
      video: "butterfliesVideo",
      description: "butterfliesDescription",
    },
    [protocols.icu.WALK_AROUND_THE_ISLAND.id]: {
      img: protocolImg["./island.png"],
      reportImg: protocolReportImg["./island.png"],
      name: "island",
      video: "islandVideo",
      description: "islandDescription",
    },
    [protocols.icu.SUNSET_AMONG_POPPIES.id]: {
      img: protocolImg["./sunset.png"],
      reportImg: protocolReportImg["./sunset.png"],
      name: "sunset",
      video: "sunsetVideo",
      description: "sunsetDescription",
    },
    [protocols.icu.CALM_IN_THE_LAKE.id]: {
      img: protocolImg["./lake.png"],
      reportImg: protocolReportImg["./lake.png"],
      name: "lake",
      video: "lakeVideo",
      description: "lakeDescription",
    },
    [protocols.icu.FLYING_OVER_THE_FIELDS.id]: {
      img: protocolImg["./fields.png"],
      reportImg: protocolReportImg["./fields.png"],
      name: "fields",
      video: "fieldsVideo",
      description: "fieldsDescription",
    },
    [protocols.icu.RELAX_ON_THE_BEACH.id]: {
      img: protocolImg["./relax_on_the_beach.png"],
      reportImg: protocolReportImg["./relax_on_the_beach.png"],
      name: "relaxOnTheBeach",
      video: "relaxOnTheBeachVideo",
      description: "relaxOnTheBeachDescription",
    },
    [protocols.icu.THE_SOUND_OF_WATER.id]: {
      img: protocolImg["./sound_of_water.png"],
      reportImg: protocolReportImg["./sound_of_water.png"],
      name: "soundOfWater",
      video: "soundOfWaterVideo",
      description: "soundOfWaterDescription",
    },
    [protocols.icu.THE_SWAY_OF_THE_WAVES.id]: {
      img: protocolImg["./waves.png"],
      reportImg: protocolReportImg["./waves.png"],
      name: "waves",
      video: "wavesVideo",
      description: "wavesDescription",
    },
  };

  return protocolsData[Number(protocolId)];
};
